import { request, cachedRequest } from './client'

// Notifications
export interface NotificationItem {
  id: number
  schedule_id: number | null
  title: string
  message: string
  type: string
  read: boolean
  attachment_path: string | null
  created_at: string | null
}

const UNREAD_TTL = 10_000 // 10s — short enough to stay fresh, long enough to dedupe concurrent calls

export const notifications = {
  list: (limit?: number) => {
    const params = limit ? `?limit=${limit}` : ''
    return request<NotificationItem[]>(`/notifications${params}`)
  },
  unreadCount: () => cachedRequest<{ count: number }>('/notifications/unread-count', undefined, UNREAD_TTL),
  markRead: (id: number) =>
    request<{ status: string }>(`/notifications/${id}/read`, { method: 'PATCH' }),
  markAllRead: () =>
    request<{ status: string }>('/notifications/mark-all-read', { method: 'POST' }),
  delete: (id: number) =>
    request<{ status: string }>(`/notifications/${id}`, { method: 'DELETE' }),
}

// Messages
export interface MessageItem {
  id: number
  sender_id: number
  sender_name: string
  recipient_id: number | null
  subject: string
  body: string
  related_type: string | null
  related_id: string | null
  vessel_name: string | null
  read: boolean
  created_at: string | null
}

export const messages = {
  list: (limit?: number) =>
    request<MessageItem[]>(`/messages${limit ? `?limit=${limit}` : ''}`),
  unreadCount: () =>
    cachedRequest<{ count: number }>('/messages/unread-count', undefined, UNREAD_TTL),
  create: (data: { subject: string; body: string; related_type?: string; related_id?: string; vessel_name?: string; recipient_id?: number }) =>
    request<MessageItem>('/messages', { method: 'POST', body: JSON.stringify(data) }),
  markRead: (id: number) =>
    request<{ status: string }>(`/messages/${id}/read`, { method: 'PATCH' }),
  markAllRead: () =>
    request<{ status: string }>('/messages/mark-all-read', { method: 'POST' }),
  delete: (id: number) =>
    request<{ status: string }>(`/messages/${id}`, { method: 'DELETE' }),
}
